// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__cnsa-","title":"ClientReferral_title__30V4k","itemText":"ClientReferral_itemText__3_DN4"};